import { PropsWithChildren } from 'react';

import styles from './form-layout.module.scss';

export default function FormContent({ children }: PropsWithChildren<{}>) {
  return <div className={styles.content}>{children}</div>;
}
